import { Model } from '@vuex-orm/core'

export default class Approvalrule extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'approvalrules'

  static primaryKey = '_id'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      _id: this.attr(null),
      departament_id: this.attr(null),
      company_id: this.attr(null),
      groups: this.attr(null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/Approvalrule.js